const invokeNative = msg => {
    if (window.webkit != undefined) {
        if (window.webkit.messageHandlers.mfAppInterface != undefined) {
            window.webkit.messageHandlers.mfAppInterface.postMessage(msg);
        }
    }
    if (window.mfAppInterface != undefined) {
        window.mfAppInterface.postMessage(msg);
    }
};

export const nativeOpenInWebview = browserUrl => {
    var pgMsg = {};
    pgMsg.pageType = "vzwcomSso";
    pgMsg.actionType = "openURL";
    pgMsg.openInWebview = true;
    pgMsg.browserUrl = browserUrl;
    pgMsg.showNativeNavigation= true;
    invokeNative(JSON.stringify(pgMsg));
};

export const openNativeSign = (L2WebpunchoutUrl, redirectLink) => {
    var pgMsg = {
    actionType : "openPage",
    requestURL : L2WebpunchoutUrl,
    extraParameters : {
    browserUrl: redirectLink
      },
    pageType : "webpunchout"
    };
    invokeNative(JSON.stringify(pgMsg));
};

export const nativeSetTitleOnly = title => {
    var tMsg = { actionType: "setTitle", title: title };
    invokeNative(JSON.stringify(tMsg));
  };